/* Poke-Geek V3 — Logos de licences des collections.
   Source unique : tous les visuels sont hébergés dans la bibliothèque Shopify Poke-Geek.
   Desktop : le logo est ancré dans la zone libre à droite du bandeau d'introduction.
   Mobile : le logo repasse naturellement sous le contenu d'introduction.
*/
(() => {
  if (window.__pgV3CollectionBrandLogosLocalReady) return;
  window.__pgV3CollectionBrandLogosLocalReady = true;

  const heroSelector =
    '#MainContent > .shopify-section:first-child .section-content-wrapper';
  const styleId = 'PgV3CollectionBrandLogosLocalStyles';
  const legacyStyleId = 'PgV3CollectionBrandLogoStyles';

  const brands = [
    {
      key: 'pokemon',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-pokemon-tcg.svg?v=1784378723',
      patterns: ['pokemon'],
    },
    {
      key: 'one-piece',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-one-piece-card-game.png?v=1784378659',
      patterns: ['one piece', 'onepiece'],
    },
    {
      key: 'yugioh',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-yugioh-tcg.png?v=1784378672',
      patterns: ['yu gi oh', 'yugioh'],
    },
    {
      key: 'dragon-ball',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-dragon-ball-super.png?v=1784378733',
      patterns: ['dragon ball', 'fusion world', 'dbs'],
    },
    {
      key: 'lorcana',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-disney-lorcana.jpg?v=1784378751',
      patterns: ['disney lorcana', 'lorcana'],
    },
    {
      key: 'magic',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-magic-the-gathering.svg?v=1784378762',
      patterns: ['magic the gathering', 'magic', 'mtg'],
    },
    {
      key: 'riftbound',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-riftbound.png?v=1784378778',
      patterns: ['riftbound'],
    },
    {
      key: 'vanguard',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-cardfight-vanguard.png?v=1784378684',
      patterns: ['cardfight vanguard', 'cardfight', 'vanguard'],
    },
    {
      key: 'kayou',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-kayou.svg?v=1784378696',
      patterns: ['kayou'],
    },
    {
      key: 'weiss-schwarz',
      src: 'https://cdn.shopify.com/s/files/1/0573/1155/9839/files/poke-geek-logo-weiss-schwarz.png?v=1784378710',
      patterns: ['weiss schwarz', 'weissschwarz'],
    },
  ];

  const normalize = (value) =>
    (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .toLowerCase()
      .replace(/[’']/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const containsPattern = (text, pattern) =>
    ` ${text} `.includes(` ${normalize(pattern)} `);

  const detectBrand = (hero) => {
    const path = normalize(window.location.pathname);
    const title = normalize(hero.querySelector('h1')?.textContent || '');
    const heroText = normalize(hero.textContent || '');
    const context = `${path} ${title} ${heroText}`;

    const matches = brands.filter((brand) =>
      brand.patterns.some((pattern) => containsPattern(context, pattern))
    );

    return matches.length === 1 ? matches[0] : null;
  };

  const ensureStyles = () => {
    document.getElementById(legacyStyleId)?.remove();
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .template-collection.pg-theme-v2
        #MainContent > .shopify-section:first-child
        .section-content-wrapper.pg-v3-collection-brand-host {
        position: relative !important;
      }

      .template-collection.pg-theme-v2 .pg-v3-collection-brand {
        display: flex;
        width: 100%;
        min-width: 0;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        pointer-events: none;
      }

      .template-collection.pg-theme-v2 .pg-v3-collection-brand__image {
        display: block;
        width: auto;
        height: auto;
        max-width: min(100%, 19rem);
        max-height: 9rem;
        object-fit: contain;
        object-position: center;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--one-piece .pg-v3-collection-brand__image {
        max-width: min(100%, 20rem);
        max-height: 8.5rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--yugioh .pg-v3-collection-brand__image {
        max-width: min(100%, 19rem);
        max-height: 8.5rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--dragon-ball .pg-v3-collection-brand__image {
        max-width: min(100%, 18rem);
        max-height: 8.5rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--lorcana .pg-v3-collection-brand__image {
        max-width: min(100%, 19rem);
        max-height: 9rem;
        mix-blend-mode: multiply;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--riftbound .pg-v3-collection-brand__image {
        max-width: min(100%, 10rem);
        max-height: 8rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--vanguard .pg-v3-collection-brand__image {
        max-width: min(100%, 20rem);
        max-height: 9rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--kayou .pg-v3-collection-brand__image {
        max-width: min(100%, 13rem);
        max-height: 7.5rem;
      }

      .template-collection.pg-theme-v2
        .pg-v3-collection-brand--weiss-schwarz .pg-v3-collection-brand__image {
        max-width: min(100%, 20rem);
        max-height: 9rem;
        mix-blend-mode: multiply;
      }

      @media screen and (min-width: 750px) {
        .template-collection.pg-theme-v2
          #MainContent > .shopify-section:first-child
          .section-content-wrapper.pg-v3-collection-brand-host {
          padding-right: clamp(20rem, 31vw, 31rem) !important;
          box-sizing: border-box;
        }

        .template-collection.pg-theme-v2 .pg-v3-collection-brand {
          position: absolute;
          top: 50%;
          right: clamp(2.5rem, 6.5vw, 7rem);
          width: clamp(15rem, 24vw, 24rem);
          height: calc(100% - 2rem);
          margin: 0;
          padding: 1rem;
          transform: translateY(-50%);
          z-index: 1;
        }
      }

      @media screen and (max-width: 749px) {
        .template-collection.pg-theme-v2 .pg-v3-collection-brand {
          position: static;
          height: auto;
          margin-top: 1rem;
          padding: 0.25rem 0 0;
          transform: none;
        }

        .template-collection.pg-theme-v2 .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--one-piece .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--yugioh .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--dragon-ball .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--lorcana .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--vanguard .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--weiss-schwarz .pg-v3-collection-brand__image {
          max-width: min(52vw, 11rem);
          max-height: 5rem;
        }

        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--kayou .pg-v3-collection-brand__image,
        .template-collection.pg-theme-v2
          .pg-v3-collection-brand--riftbound .pg-v3-collection-brand__image {
          max-width: min(34vw, 7rem);
          max-height: 4.25rem;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const reconcile = () => {
    const body = document.body;
    if (
      !body?.classList.contains('template-collection') ||
      !body.classList.contains('pg-theme-v2')
    ) {
      return;
    }

    const hero = document.querySelector(heroSelector);
    if (!(hero instanceof HTMLElement)) return;

    ensureStyles();

    hero.classList.remove('pg-v3-collection-hero-ready');

    const brand = detectBrand(hero);
    const existing = Array.from(
      hero.querySelectorAll(':scope > .pg-v3-collection-brand')
    );

    if (!brand) {
      hero.classList.remove('pg-v3-collection-brand-host');
      existing.forEach((node) => node.remove());
      return;
    }

    hero.classList.add('pg-v3-collection-brand-host');

    const container = existing.shift() || document.createElement('div');
    existing.forEach((duplicate) => duplicate.remove());

    container.className =
      `pg-v3-collection-brand pg-v3-collection-brand--${brand.key}`;
    container.setAttribute('aria-hidden', 'true');

    let image = container.querySelector('.pg-v3-collection-brand__image');
    if (!(image instanceof HTMLImageElement)) {
      container.replaceChildren();
      image = new Image();
      image.className = 'pg-v3-collection-brand__image';
      image.alt = '';
      image.decoding = 'async';
      image.loading = 'eager';
      container.appendChild(image);
    }

    image.onerror = () => {
      container.remove();
      hero.classList.remove('pg-v3-collection-brand-host');
    };

    if (image.getAttribute('src') !== brand.src) {
      image.src = brand.src;
    }

    if (container.parentElement !== hero) {
      hero.appendChild(container);
    }
  };

  const boot = () => {
    reconcile();

    const main = document.getElementById('MainContent');
    if (!(main instanceof HTMLElement)) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;

      requestAnimationFrame(() => {
        queued = false;
        reconcile();
      });
    });

    observer.observe(main, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', reconcile, { once: true });
  document.addEventListener('shopify:section:load', reconcile);
})();
